import PropTypes from 'prop-types'
import styled from 'styled-components'
import Img from 'components/Img'
import Dot from 'components/Dot'
import Fade from 'components/State/Fade'
import Box from '@mui/material/Box'
import { IconAnonUser } from 'icons'

const ImgContainer = styled(Box).attrs(props => ({
  height: props.$size,
  width: props.$size,
  overflow: 'hidden',
  display: props.$hasImg ? undefined : 'grid',
  justifyContent: 'center',
  alignItems: 'center',
  bgcolor: props.$hasImg ? undefined : 'background.neutral_500.main',
}))`
  border-radius: 100%;
  transition: ${props => props.theme.internalMixins.setTransition(['width', 'height'])};
`

const LogoImg = styled(Img).attrs(props => ({
  src: props.src,
  fit: 'cover',
  size: '65%',
}))`
  position: absolute;
  bottom: 0;
  right: 0;
  ${props =>
    props.borderType === 'shadow'
      ? `
    box-shadow: ${props.theme.elevation[200]};
  `
      : `
    border: ${props.theme.globals.border.neutral_100};
  `}
`

const Avatar = ({
  src,
  logoSrc,
  size,
  circleSize,
  borderType,
  error,
}) => (
  <Box
    className="avatar"
    position="relative"
  >
    <ImgContainer $size={size} $hasImg={!!src?.length}>
      {!!src?.length && <Img src={src} circle="100%" bg />}
      {!src?.length && <IconAnonUser height="100%" width="100%" />}
    </ImgContainer>
    {!!logoSrc && (
      <LogoImg src={logoSrc} circle={circleSize} borderType={borderType} />
    )}
    <Box position="absolute" top="1px" right="1px">
      <Fade active={!!error}>
        <Dot
          size="md"
        />
      </Fade>
    </Box>
  </Box>
)

Avatar.propTypes = {
  src: PropTypes.string,
  logoSrc: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  circleSize: PropTypes.string,
  borderType: PropTypes.oneOf(['shadow', 'solid']),
  initials: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

Avatar.defaultProps = {
  src: '',
  size: { xx: '60px' },
  circleSize: '25px',
  borderType: 'shadow',
  initials: '',
}

export default Avatar
